import { render, staticRenderFns } from "./AdjuntoDataC.vue?vue&type=template&id=2518ea4a&"
import script from "./AdjuntoDataC.vue?vue&type=script&lang=js&"
export * from "./AdjuntoDataC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports